module.exports = __webpack_public_path__ + "static/media/link-share.2ed84777.svg";